
///
/// Search Magnifying Glass Icon
/// i.e. mobile search form expander
///
 

window.SetUpMobileSearchExpander = function() {

	var searchToggleIcon = document.querySelector('.magnifying-glass');
	var searchForm = document.querySelector('#SearchForm')
	var expandedClassName = 'expanded';

	var nav = document.querySelector('#MobileNavigation');
	var burgerMenu = document.querySelector('#BurgerMenu');
	
	//
	// Add a click event handler to the search expander icon element to toggle the showing and hiding of the search bar
	//
	searchToggleIcon.addEventListener('click', function () {
		if (searchForm.classList.contains(expandedClassName)) {
			// search is already expanded -> close it
			this.setAttribute('aria-expanded', 'false');
			searchForm.classList.remove(expandedClassName);
		} else {
			// is the dropdown navigation opened?
			if (nav.classList.contains(expandedClassName)) {
				// close it
				nav.classList.remove(expandedClassName);
				burgerMenu.classList.remove(expandedClassName);
				burgerMenu.setAttribute('aria-expanded', 'false');
			}
			// search is not expanded -> open it
			searchForm.classList.add(expandedClassName);
			this.setAttribute('aria-expanded', 'true');
		}
	});
}

if (document.readyState !== 'loading') {
	window.SetUpMobileSearchExpander();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetUpMobileSearchExpander();
	});
}